import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import {AnalysisResultsActions} from '../actions';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.AnalysisResult };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
  pagination?: {
    current?: string;
    first?: string;
    last?: string;
    next?: string;
    previous?: string;
  };
  totalItems: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false,
  totalItems: 0
};

export const reducer = createReducer(
  initialState,
  on(
    AnalysisResultsActions.CreateAnalysisResult,
    AnalysisResultsActions.ReadAnalysisResult,
    AnalysisResultsActions.ReadAnalysisResults,
    AnalysisResultsActions.UpdateAnalysisResult,
    AnalysisResultsActions.DeleteAnalysisResult,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    AnalysisResultsActions.CreateAnalysisResultSuccess,
    AnalysisResultsActions.UpdateAnalysisResultSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    AnalysisResultsActions.ReadAnalysisResultsSuccess,
    AnalysisResultsActions.ReadAnalysisResultsChunkSuccess,
    (state, { response }) => {
      const hasPagination = response.hasOwnProperty('hydra:view');
      const items = response['hydra:member'];
      const totalItems = response['hydra:totalItems'];
      let pagination = {};
      const entities = items.reduce(
        (
          entities: {
            [iri: string]: fromModuleModels.AnalysisResult
          },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        {}
      );
      if (hasPagination) {
        pagination = {
          first: response['hydra:view']['hydra:first'],
          current: response['hydra:view']['@id'],
          last: response['hydra:view']['hydra:last']
        };
        console.log(pagination);
        if (response['hydra:view'].hasOwnProperty('hydra:previous')) {
          pagination = {
            ...pagination,
            previous: response['hydra:view']['hydra:previous']
          };
        }

        if (response['hydra:view'].hasOwnProperty('hydra:next')) {
          pagination = {
            ...pagination,
            next: response['hydra:view']['hydra:next']
          };
        }
      }
      return {
        ...state,
        entities,
        pagination,
        totalItems,
        loading: false,
        loaded: true
      };
    }
  ),
  on(AnalysisResultsActions.DeleteAnalysisResultSuccess, (state, { iri }) => {
    const { [iri]: removedItem, ...entities }: any = state.entities;

    return {
      ...state,
      entities,
      loading: false,
      loaded: false
    };
  }),
  on(
    AnalysisResultsActions.CreateAnalysisResultFail,
    AnalysisResultsActions.UpdateAnalysisResultFail,
    AnalysisResultsActions.DeleteAnalysisResultFail,
    AnalysisResultsActions.ReadAnalysisResultsChunkFail,
    state => {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
